import styled from 'styled-components'

type SectionSubtitleProps = {
  color?: string
  left?: boolean
}

const SectionSubtitle = styled.h6<SectionSubtitleProps>`
  ${(props) => props.theme.typography.h6}
  color: ${(props) =>
    props.color ? props.color : props.theme.color.black.regular};
  margin: 0 0 40px 0;
  margin-right: auto;
  text-align: ${(props) => (props.left ? 'left' : 'center')};

  @media (max-width: ${(props) => props.theme.screen.sm}) {
    ${(props) => props.theme.typography.body2}
    margin: 0 0 40px;
    text-align: left;
  }
`

export default SectionSubtitle
